import { JSX } from 'react'

import { IconProps } from '../../icon'

const ChevronLeft: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_1651_4483)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.6112 34.5397C31.2248 33.9261 31.2248 32.9311 30.6112 32.3174L22.2937 24L30.6112 15.6826C31.2248 15.0689 31.2248 14.0739 30.6112 13.4603C29.9975 12.8466 29.0025 12.8466 28.3888 13.4603L18.9602 22.8888C18.3466 23.5025 18.3466 24.4975 18.9602 25.1112L28.3888 34.5397C29.0025 35.1534 29.9975 35.1534 30.6112 34.5397Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_1651_4483'>
        <rect width='48' height='48' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)

export default ChevronLeft
